import { getRouteParams } from '../../routing/getRouteParams';
export const getIsUserFromFreeCrmPage = () => {
  const {
    queryParams
  } = getRouteParams();
  const hubsSignupUrl = queryParams['hubs_signup-url'];
  return hubsSignupUrl ? hubsSignupUrl.includes('www.hubspot.com/products/crm') : false;
};